import { useState } from "react";
import { filmFilters, filmTopics } from "@/mocks/home";

export default function FilmHighlights() {
  const [active, setActive] = useState("全部");

  const list =
    active === "全部" ? filmTopics : filmTopics.filter((t) => t.category === active);

  return (
    <section id="films" className="scroll-mt-20 bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              大师兄电影 · 题材方向
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
              六个常见方向，各有不同的看点
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              下面按动作、喜剧、剧情三类，把大师兄电影里常见的六个方向分开整理。点击标签即可筛选，每一张卡片都注明了具体该看什么。
            </p>
          </div>
          <div className="flex flex-wrap gap-2">
            {filmFilters.map((f) => (
              <button
                key={f}
                type="button"
                onClick={() => setActive(f)}
                className={
                  active === f
                    ? "cursor-pointer whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors"
                    : "cursor-pointer whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
                }
              >
                {f}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((topic) => (
            <article
              key={topic.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="h-44 w-full overflow-hidden bg-background-200">
                <img
                  src={topic.image}
                  alt={`${topic.title}的暖色氛围示意图`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex items-center gap-2">
                  <span className="inline-flex items-center rounded-full bg-accent-100 px-2.5 py-1 text-xs font-medium text-accent-800">
                    {topic.category}
                  </span>
                  <span className="text-xs text-foreground-500">{topic.tag}</span>
                </div>
                <h3 className="mt-3 font-heading text-lg font-bold text-foreground-950">
                  {topic.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{topic.desc}</p>
                <ul className="mt-4 space-y-2 border-t border-background-200/70 pt-4">
                  {topic.points.map((pt) => (
                    <li key={pt} className="flex items-start gap-2 text-xs text-foreground-700 md:text-sm">
                      <i className="ri-arrow-right-s-line mt-0.5 flex-none text-primary-500" />
                      {pt}
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>

        <p className="mt-8 text-center text-xs text-foreground-500">
          以上为题材方向的概括性整理，用于了解不同类型的观看重点；具体作品信息请以官方资料为准。
        </p>
      </div>
    </section>
  );
}